var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PdpTabBase',{staticClass:"pdp-hints-tab",class:_vm.classes,attrs:{"headline":_vm.$t('pdp-hints-tab.headline'),"data-preload":[_vm.$options.name],"is-expanded":_vm.activeTab}},[_c('div',{staticClass:"pdp-hints-tab__content",attrs:{"tabindex":"0"},domProps:{"innerHTML":_vm._s(_vm.$t(`pdp-hints-tab.content.${_vm.articleType}`))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }